import { render, staticRenderFns } from "./OptionalFeed.vue?vue&type=template&id=552d7e29&"
import script from "./OptionalFeed.vue?vue&type=script&lang=ts&"
export * from "./OptionalFeed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports